<template lang="html">
  <div>
    <div class="content">
      <h1>Objednávky</h1>
      <v-layout class="layout--controls">
        <v-btn
          color="secondary"
          class="button--top control"
          @click="downloadExport"
          :loading="exportLoading"
        >
          Exportovat
        </v-btn>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="search"
        ></v-text-field>
        <v-checkbox v-model="booksOnly" hide-details label="Tištěná kniha" />
      </v-layout>
        <v-alert v-if="exportLoading" type="warning" dense>
            Exportuje se {{total}} objenávek. Připrava bude chvíli trvat, prosím vyčkejte.
        </v-alert>
      <v-layout class="table-items">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="total"
          :loading="!loaded"
          item-key="name"
          :items-per-page="perPage"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template #progress>
            <div></div>
          </template>
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'OrdersDetail', params: { id: item.id } }"
                >
                  <td class="">{{ item.id }}</td>
                  <td class="bolder small">
                    {{ item.number
                    }}<span v-if="item.ios_receipt" class="apple-order"></span>
                    <span
                      v-if="item.delivery_point_type"
                      class="book-order--tag"
                    ></span>
                  </td>
                  <td class="bold">
                    <router-link
                      :to="{
                        name: 'CustomersDetail',
                        params: { id: item.user_id },
                      }"
                    >
                      {{ item.user_forename }} {{ item.user_surname }}<br />
                      <span class="small normal">{{ item.user_email }}</span>
                    </router-link>
                  </td>
                  <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                  <td class="">{{ item.items_count }}</td>
                  <td class="bold">
                    <span
                      v-bind:class="[
                        { 'normal small': !item.dph },
                        { 'actual-price': item.dph },
                      ]"
                    >
                      <template v-if="item.currency == 'CZK'">
                        <span v-if="item.price"> {{ item.price }} Kč </span>
                        <span v-else>
                          0 Kč
                        </span></template
                      >
                      <template v-if="item.currency == 'EUR'">
                        <span v-if="item.price_eur">
                          {{ item.price_eur }} €
                        </span>
                        <span v-else>
                          0 €
                        </span></template
                      >
                    </span>
                    <br />
                    <span
                      v-bind:class="[
                        { 'normal small': item.dph },
                        { 'actual-price': !item.dph },
                      ]"
                      ><span class="small">Bez DPH</span>
                      <span v-if="item.currency == 'CZK'">
                        {{ item.price_no_dph }} Kč</span
                      >
                      <span v-if="item.currency == 'EUR'">
                        {{ item.price_eur_no_dph }} €
                      </span>
                    </span>
                  </td>
                  <td class="small bold">
                    <span v-if="item.status === 'created'" class="status">{{
                      item.status_name
                    }}</span>
                    <span
                      v-else-if="item.status === 'canceled'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'storned'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'paid'"
                      class="status status--success"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'timeouted'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'refunded'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span v-else class="status status--normal"
                      ><span>{{ item.status_name }}</span></span
                    >
                  </td>

                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná objednávka nebyla nalezena</p>
              </div>
              <v-overlay
                  absolute
                  color="rgba(255, 255, 255, 0.8)"
                  :value="!loaded"
              >
                <div>
                  <div class="loader">
                    <div class="loader__item">
                    </div>
                  </div>
                </div>
              </v-overlay>
            </tbody>
          </template>

          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet objednávek na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex';
import VueJsonToCsv from 'vue-json-to-csv';
import {debounce} from "lodash";

export default {
  name: 'Orders',
  components: {
    VueJsonToCsv,
  },

  data() {
    return {
      json: {
        data: [],
        labels: {},
        title: 'Objednávky',
        file: 'Objednávky',
        meta: [
          [
            {
              key: 'charset',
              value: 'utf-8',
            },
          ],
        ],
      },
      loaded: false,
      booksOnly: false,
      search: '',
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: 'ID', value: 'id', align: 'left' },
        { text: 'Číslo objednávky', value: 'number', align: 'left' },
        { text: 'Zákazník', value: 'user_email', align: 'left' },
        { text: 'Vytvořeno', value: 'created_at', align: 'left' },
        { text: 'Počet produktů', value: 'items_count', align: 'left', sortable: false },
        { text: 'Cena', value: 'price', align: 'left' },
        { text: 'Stav', value: 'status', align: 'left' },
        /* { text: 'Gopay ID', value: 'gopay_id',  align: 'left',  },
                { text: 'Vyfakturuj ID', value: 'vyfakturuj_id',  align: 'left',  },*/
        { text: '', value: 'controls', align: 'right' },
      ],
      items: [],
      itemsCopy: [],
      options: {},
      total: 0,
      perPage: 30,
      stop: false,
      exportLoading: false,
    };
  },

  created() {
    this.fetchData();
  },
  computed: {
    ...mapState(['profile']),
    exportLink() {
      return process.env.VUE_APP_API_BASE_URL + '/admin/orders.xlsx?token=' + localStorage.getItem('token');
    },
  },
  mounted() {},
  methods: {
    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
      async downloadExport() {
          this.exportLoading = true;
          const response = await this.$axios.get(this.exportLink, {
              responseType: 'blob',
          });
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;

          // Use filename from Content-Disposition if server sends it
          const disposition = response.headers['content-disposition'];
          let filename = "export.xlsx";
          if (disposition && disposition.indexOf('filename=') !== -1) {
              filename = disposition.split('filename=')[1].replace(/['"]/g, '');
          }

          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          this.exportLoading = false;
      },
    fetchData() {
      this.loaded = false;
      this.items = [];
      const params = {};
      if(this.options.page){
        params.page = this.options.page;
      }
      if(this.options.itemsPerPage)
      {
        params.perPage = this.options.itemsPerPage;
      }
      if(this.options.sortBy && this.options.sortBy.length > 0){
        params.sortBy = this.options.sortBy[0];
      }
      if(this.options.sortDesc && this.options.sortDesc.length > 0){
        params.order = this.options.sortDesc[0] ? 'DESC' : 'ASC';
      }
      if(this.search && this.search.length > 0){
        params.search = this.search;
      }
      if(this.booksOnly){
        params.books_only = 1;
      }

      this.$axios
        .get('/admin/orders', { params })
        .then((response) => {
          response.data.orders.forEach((item) => {
            if (item.status === 'created') {
              item.status_name = 'Vytvořena';
            } else if (item.status === 'canceled') {
              item.status_name = 'Zrušena';
            } else if (item.status === 'storned') {
              item.status_name = 'Stornována';
            } else if (item.status === 'paid') {
              item.status_name = 'Zaplacena';
            } else if (item.status === 'timeouted') {
              item.status_name = 'Vypršela';
            } else if (item.status === 'to_ship') {
              item.status_name = 'K odeslání';
            } else if (item.status === 'shipped') {
              item.status_name = 'Odeslána';
            } else if (item.status === 'refunded') {
              item.status_name = 'Platba vrácena';
            } else {
              if (item.status) {
                item.status_name = 'Neznámý - ' + item.status;
              } else {
                item.status_name = 'Neznámý';
              }
            }
          });

          this.items = response.data.orders;
          this.total = response.data.count;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
    search: debounce(function() {
      this.fetchData();
    }, 350),
    booksOnly() {
      this.fetchData();
    }
  },
};
</script>

<style lang="scss">
.book-order--tag {
  height: 10px;
  width: 10px;
  border-radius: 100%;
  background-color: #0a284a;
  display: inline-block;
  margin-left: 4px;
}
</style>
